import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57cd2abe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contnet-warp" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-round-bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content-warp-round-bg-r" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "content-warp-round-bg-left" }),
    /*#__PURE__*/_createElementVNode("div", { class: "content-warp-round-bg-right" })
  ])
], -1))
const _hoisted_3 = { class: "content-warp-round-tip" }
const _hoisted_4 = { class: "text-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-numbder" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-item-bg" }, null, -1))
const _hoisted_7 = { class: "text-item-inner" }
const _hoisted_8 = { class: "content-warp-round-icon" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "content-name" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-color" }, null, -1))

import { ref, computed, onMounted } from 'vue';
import { baseSvg } from './svg-components/index';
import {
  pcModulePatientSex5,
  selfAdaption,
  useDataAssembly
  // sequence
} from './hooks';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2-5',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;
const svgHTML = ref('');
let data = useDataAssembly(props.tableHeaderList, props.tableDataList, true);
const splitCount = computed(() => {
  return Math.ceil(data.value.tipData.flat(1).length / 2);
});
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
const RefIcon = ref<HTMLDivElement>();
const RefTextItem = ref<Array<HTMLDivElement>>();
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex5(RefIcon, RefTextItem, splitCount, svgHTML);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "patient-sex",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "contnet",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data)['tipData'], (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["content-warp-round-tip-item", { 'justify-contents': splitCount.value < 3 }]),
              key: index,
              style: _normalizeStyle({
              '--location': index == 0 ? '-7.5px' : '180.5px'
            })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (text, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text",
                  ref_for: true,
                  ref_key: "RefTextItem",
                  ref: RefTextItem,
                  key: index,
                  style: _normalizeStyle({
                '--color': `var(--theme-color-${text[text.length - 1]},#000)`
              })
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(text.slice(0, text.length - 1), (citem, cindex) => {
                          return (_openBlock(), _createElementBlock("div", { key: cindex }, _toDisplayString(citem.label) + "：" + _toDisplayString(citem.value), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ], 4))
              }), 128))
            ], 6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "content-warp-round-icon-warp",
            ref_key: "RefIcon",
            ref: RefIcon
          }, [
            _createVNode(_unref(baseSvg))
          ], 512),
          _createElementVNode("div", {
            class: "line",
            innerHTML: svgHTML.value
          }, null, 8, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` }),
              key: index
            }, [
              _hoisted_11,
              _createElementVNode("div", null, _toDisplayString(item.value), 1)
            ], 4))
          }), 128))
        ])
      ])
    ], 512)
  ], 4))
}
}

})